import { ComponentBase } from '../../../../component-base';
import { IMouseDown, IMouseMove, IMouseRelease, IDoubleClick } from '../../Interfaces';
import { MoveShapeComponent } from './MoveShapeComponent';
import { MovePostComponent } from './MovePostComponent';
import { DrawingsHolderService } from '../../drawings-holder.service';
import { SelectableIntermediatePost, SelectablePicket } from '../../object3D';
import { Injectable } from '@angular/core';
import { PositionCalculatorService } from '../../position-calculator.service';
import { SelectComponent } from '..';

@Injectable()
export class MoveObjectComponent extends ComponentBase
  implements IMouseMove, IMouseDown, IMouseRelease, IDoubleClick {
  dblclick(e: MouseEvent): boolean {
    this.selectComponent.mouseUp(e);
    return true;
  }

  private activeMoveComponent: IMouseDown & IMouseMove & IMouseRelease;
  private moveShape: MoveShapeComponent;
  private movePost: MovePostComponent;

  constructor(
    private drawingsHolderService: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
    this.moveShape = new MoveShapeComponent(this.drawingsHolderService, this.positionCalculator);
    this.movePost = new MovePostComponent(this.positionCalculator, this.drawingsHolderService);
    drawingsHolderService.onSelect.subscribe(obj => {
      if (obj) {
        this.activeMoveComponent =
          obj[0] instanceof SelectableIntermediatePost ||
          (obj[0] instanceof SelectablePicket && obj[0].edge)
            ? this.movePost
            : this.moveShape;
      }
    });
  }

  mouseDown(e: MouseEvent): boolean {
    return this.activeMoveComponent.mouseDown(e);
  }

  mouseMove(e: MouseEvent): boolean {
    return this.activeMoveComponent.mouseMove(e);
  }

  mouseUp(e: MouseEvent): boolean {
    return this.activeMoveComponent.mouseUp(e);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveObjectComponent/index.ts